
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("dh2HY", function(module, exports) {

$parcel$export(module.exports, "register", function () { return $9a9ef6add79e22e6$export$6503ec6e8aabbaf; }, function (v) { return $9a9ef6add79e22e6$export$6503ec6e8aabbaf = v; });
var $9a9ef6add79e22e6$export$6503ec6e8aabbaf;
var $9a9ef6add79e22e6$export$f7ad0328861e2f03;
"use strict";
var $9a9ef6add79e22e6$var$mapping = new Map();
function $9a9ef6add79e22e6$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$9a9ef6add79e22e6$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $9a9ef6add79e22e6$var$resolve(id) {
    var resolved = $9a9ef6add79e22e6$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$9a9ef6add79e22e6$export$6503ec6e8aabbaf = $9a9ef6add79e22e6$var$register;
$9a9ef6add79e22e6$export$f7ad0328861e2f03 = $9a9ef6add79e22e6$var$resolve;

});

var $43e6ac863fcf66d0$exports = {};

(parcelRequire("dh2HY")).register(new URL("", import.meta.url).toString(), JSON.parse("[\"cbCar\",\"index.bc83dfed.js\",\"fFIhT\",\"amazon_icon.637b370d.svg\",\"kuw6m\",\"archive_icon.b93ca50a.svg\",\"mgJtf\",\"generic_link_icon.3aa6c58d.svg\",\"hoX1E\",\"opengraph_banner.c6e2d394.png\",\"7BQ49\",\"typesense.3867b908.svg\",\"4crv4\",\"index.b43ed3ba.js\"]"));


var $9YEav = parcelRequire("9YEav");
parcelRequire("fJThW");

var $a9ZSp = parcelRequire("a9ZSp");

var $hHIOY = parcelRequire("hHIOY");
var $e2pZd = parcelRequire("e2pZd");
var $d5S8e = parcelRequire("d5S8e");
var $2wrqp = parcelRequire("2wrqp");
var $5bown = parcelRequire("5bown");

var $lLkqw = parcelRequire("lLkqw");

var $jv2Ed = parcelRequire("jv2Ed");

var $6YH5z = parcelRequire("6YH5z");
var $kooa4 = parcelRequire("kooa4");
var $fMELL = parcelRequire("fMELL");
function $ae145701892959ed$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $ae145701892959ed$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $ae145701892959ed$var$_typeof(obj);
}
function $ae145701892959ed$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $ae145701892959ed$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $ae145701892959ed$var$ownKeys(Object(source), !0).forEach(function(key) {
            $ae145701892959ed$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $ae145701892959ed$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $ae145701892959ed$var$_defineProperty(obj, key, value) {
    key = $ae145701892959ed$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $ae145701892959ed$var$_toPropertyKey(arg) {
    var key = $ae145701892959ed$var$_toPrimitive(arg, "string");
    return $ae145701892959ed$var$_typeof(key) === "symbol" ? key : String(key);
}
function $ae145701892959ed$var$_toPrimitive(input, hint) {
    if ($ae145701892959ed$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($ae145701892959ed$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var $ae145701892959ed$var$withUsage = (0, $kooa4.createDocumentationMessageGenerator)({
    name: 'search-box',
    connector: true
});
/**
 * @typedef {Object} CustomSearchBoxWidgetParams
 * @property {function(string, function(string))} [queryHook = undefined] A function that will be called every time
 * a new value for the query is set. The first parameter is the query and the second is a
 * function to actually trigger the search. The function takes the query as the parameter.
 *
 * This queryHook can be used to debounce the number of searches done from the searchBox.
 */ var $ae145701892959ed$var$defaultQueryHook = function defaultQueryHook(query, hook) {
    return hook(query);
};
/**
 * **SearchBox** connector provides the logic to build a widget that will let the user search for a query.
 *
 * The connector provides to the rendering: `refine()` to set the query. The behaviour of this function
 * may be impacted by the `queryHook` widget parameter.
 */ var $ae145701892959ed$var$connectSearchBox = function connectSearchBox(renderFn) {
    var unmountFn = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (0, $fMELL.noop);
    (0, $6YH5z.checkRendering)(renderFn, $ae145701892959ed$var$withUsage());
    return function(widgetParams) {
        var _ref = widgetParams || {}, _ref$queryHook = _ref.queryHook, queryHook = _ref$queryHook === void 0 ? $ae145701892959ed$var$defaultQueryHook : _ref$queryHook;
        var _refine;
        var _clear;
        return {
            $$type: 'ais.searchBox',
            init: function init(initOptions) {
                var instantSearchInstance = initOptions.instantSearchInstance;
                renderFn($ae145701892959ed$var$_objectSpread($ae145701892959ed$var$_objectSpread({}, this.getWidgetRenderState(initOptions)), {}, {
                    instantSearchInstance: instantSearchInstance
                }), true);
            },
            render: function render(renderOptions) {
                var instantSearchInstance = renderOptions.instantSearchInstance;
                renderFn($ae145701892959ed$var$_objectSpread($ae145701892959ed$var$_objectSpread({}, this.getWidgetRenderState(renderOptions)), {}, {
                    instantSearchInstance: instantSearchInstance
                }), false);
            },
            dispose: function dispose(_ref2) {
                var state = _ref2.state;
                unmountFn();
                return state.setQueryParameter('query', undefined);
            },
            getRenderState: function getRenderState(renderState, renderOptions) {
                return $ae145701892959ed$var$_objectSpread($ae145701892959ed$var$_objectSpread({}, renderState), {}, {
                    searchBox: this.getWidgetRenderState(renderOptions)
                });
            },
            getWidgetRenderState: function getWidgetRenderState(_ref3) {
                var helper = _ref3.helper, instantSearchInstance = _ref3.instantSearchInstance, state = _ref3.state;
                if (!_refine) {
                    _refine = function _refine(query) {
                        queryHook(query, function(q) {
                            return helper.setQuery(q).search();
                        });
                    };
                    _clear = function _clear() {
                        helper.setQuery('').search();
                    };
                }
                return {
                    query: state.query || '',
                    refine: _refine,
                    clear: _clear,
                    widgetParams: widgetParams,
                    isSearchStalled: instantSearchInstance.status === 'stalled'
                };
            },
            getWidgetUiState: function getWidgetUiState(uiState, _ref4) {
                var searchParameters = _ref4.searchParameters;
                var query = searchParameters.query || '';
                if (query === '' || uiState && uiState.query === query) return uiState;
                return $ae145701892959ed$var$_objectSpread($ae145701892959ed$var$_objectSpread({}, uiState), {}, {
                    query: query
                });
            },
            getWidgetSearchParameters: function getWidgetSearchParameters(searchParameters, _ref5) {
                var uiState = _ref5.uiState;
                return searchParameters.setQueryParameter('query', uiState.query || '');
            }
        };
    };
};
var $ae145701892959ed$export$2e2bcd8739ae039 = $ae145701892959ed$var$connectSearchBox;



var $8JLyQ = parcelRequire("8JLyQ");

var $kooa4 = parcelRequire("kooa4");
var $hthTp = parcelRequire("hthTp");

var $gl0jp = parcelRequire("gl0jp");
function $6692ff1d889f1f11$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $6692ff1d889f1f11$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $6692ff1d889f1f11$var$_typeof(obj);
}
function $6692ff1d889f1f11$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $6692ff1d889f1f11$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $6692ff1d889f1f11$var$ownKeys(Object(source), !0).forEach(function(key) {
            $6692ff1d889f1f11$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $6692ff1d889f1f11$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $6692ff1d889f1f11$var$_defineProperty(obj, key, value) {
    key = $6692ff1d889f1f11$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $6692ff1d889f1f11$var$_toPropertyKey(arg) {
    var key = $6692ff1d889f1f11$var$_toPrimitive(arg, "string");
    return $6692ff1d889f1f11$var$_typeof(key) === "symbol" ? key : String(key);
}
function $6692ff1d889f1f11$var$_toPrimitive(input, hint) {
    if ($6692ff1d889f1f11$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($6692ff1d889f1f11$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var $6692ff1d889f1f11$var$withUsage = (0, $kooa4.createDocumentationMessageGenerator)({
    name: 'search-box'
});
var $6692ff1d889f1f11$var$suit = (0, $8JLyQ.component)('SearchBox');
var $6692ff1d889f1f11$var$renderer = function renderer(_ref) {
    var containerNode = _ref.containerNode, cssClasses = _ref.cssClasses, placeholder = _ref.placeholder, templates = _ref.templates, autofocus = _ref.autofocus, searchAsYouType = _ref.searchAsYouType, ignoreCompositionEvents = _ref.ignoreCompositionEvents, showReset = _ref.showReset, showSubmit = _ref.showSubmit, showLoadingIndicator = _ref.showLoadingIndicator;
    return function(_ref2) {
        var refine = _ref2.refine, query = _ref2.query, isSearchStalled = _ref2.isSearchStalled;
        (0, $lLkqw.render)((0, $lLkqw.h)((0, $jv2Ed.default), {
            query: query,
            placeholder: placeholder,
            autofocus: autofocus,
            refine: refine,
            searchAsYouType: searchAsYouType,
            ignoreCompositionEvents: ignoreCompositionEvents,
            templates: templates,
            showSubmit: showSubmit,
            showReset: showReset,
            showLoadingIndicator: showLoadingIndicator,
            isSearchStalled: isSearchStalled,
            cssClasses: cssClasses
        }), containerNode);
    };
};
/**
 * The searchbox widget is used to let the user set a text based query.
 *
 * This is usually the  main entry point to start the search in an instantsearch context. For that
 * reason is usually placed on top, and not hidden so that the user can start searching right
 * away.
 *
 */ var $6692ff1d889f1f11$var$searchBox = function searchBox(widgetParams) {
    var _ref3 = widgetParams || {}, container = _ref3.container, _ref3$placeholder = _ref3.placeholder, placeholder = _ref3$placeholder === void 0 ? '' : _ref3$placeholder, _ref3$cssClasses = _ref3.cssClasses, userCssClasses = _ref3$cssClasses === void 0 ? {} : _ref3$cssClasses, _ref3$autofocus = _ref3.autofocus, autofocus = _ref3$autofocus === void 0 ? false : _ref3$autofocus, _ref3$searchAsYouType = _ref3.searchAsYouType, searchAsYouType = _ref3$searchAsYouType === void 0 ? true : _ref3$searchAsYouType, _ref3$ignoreCompositi = _ref3.ignoreCompositionEvents, ignoreCompositionEvents = _ref3$ignoreCompositi === void 0 ? false : _ref3$ignoreCompositi, _ref3$showReset = _ref3.showReset, showReset = _ref3$showReset === void 0 ? true : _ref3$showReset, _ref3$showSubmit = _ref3.showSubmit, showSubmit = _ref3$showSubmit === void 0 ? true : _ref3$showSubmit, _ref3$showLoadingIndi = _ref3.showLoadingIndicator, showLoadingIndicator = _ref3$showLoadingIndi === void 0 ? true : _ref3$showLoadingIndi, queryHook = _ref3.queryHook, _ref3$templates = _ref3.templates, userTemplates = _ref3$templates === void 0 ? {} : _ref3$templates;
    if (!container) throw new Error($6692ff1d889f1f11$var$withUsage('The `container` option is required.'));
    var containerNode = (0, $hthTp.getContainerNode)(container);
    var cssClasses = {
        root: (0, $5bown.cx)($6692ff1d889f1f11$var$suit(), userCssClasses.root),
        form: (0, $5bown.cx)($6692ff1d889f1f11$var$suit({
            descendantName: 'form'
        }), userCssClasses.form),
        input: (0, $5bown.cx)($6692ff1d889f1f11$var$suit({
            descendantName: 'input'
        }), userCssClasses.input),
        submit: (0, $5bown.cx)($6692ff1d889f1f11$var$suit({
            descendantName: 'submit'
        }), userCssClasses.submit),
        submitIcon: (0, $5bown.cx)($6692ff1d889f1f11$var$suit({
            descendantName: 'submitIcon'
        }), userCssClasses.submitIcon),
        reset: (0, $5bown.cx)($6692ff1d889f1f11$var$suit({
            descendantName: 'reset'
        }), userCssClasses.reset),
        resetIcon: (0, $5bown.cx)($6692ff1d889f1f11$var$suit({
            descendantName: 'resetIcon'
        }), userCssClasses.resetIcon),
        loadingIndicator: (0, $5bown.cx)($6692ff1d889f1f11$var$suit({
            descendantName: 'loadingIndicator'
        }), userCssClasses.loadingIndicator),
        loadingIcon: (0, $5bown.cx)($6692ff1d889f1f11$var$suit({
            descendantName: 'loadingIcon'
        }), userCssClasses.loadingIcon)
    };
    var templates = $6692ff1d889f1f11$var$_objectSpread($6692ff1d889f1f11$var$_objectSpread({}, (0, $gl0jp.default)), userTemplates);
    var specializedRenderer = $6692ff1d889f1f11$var$renderer({
        containerNode: containerNode,
        cssClasses: cssClasses,
        placeholder: placeholder,
        templates: templates,
        autofocus: autofocus,
        searchAsYouType: searchAsYouType,
        ignoreCompositionEvents: ignoreCompositionEvents,
        showReset: showReset,
        showSubmit: showSubmit,
        showLoadingIndicator: showLoadingIndicator
    });
    var makeWidget = (0, $ae145701892959ed$export$2e2bcd8739ae039)(specializedRenderer, function() {
        return (0, $lLkqw.render)(null, containerNode);
    });
    return $6692ff1d889f1f11$var$_objectSpread($6692ff1d889f1f11$var$_objectSpread({}, makeWidget({
        queryHook: queryHook
    })), {}, {
        $$widgetType: 'ais.searchBox'
    });
};
var $6692ff1d889f1f11$export$2e2bcd8739ae039 = $6692ff1d889f1f11$var$searchBox;


var $5bown = parcelRequire("5bown");

var $lLkqw = parcelRequire("lLkqw");

var $5bown = parcelRequire("5bown");

var $lLkqw = parcelRequire("lLkqw");
function $ab2fa6417f0ecf8b$var$Selector(_ref) {
    var currentValue = _ref.currentValue, options = _ref.options, cssClasses = _ref.cssClasses, setValue = _ref.setValue, ariaLabel = _ref.ariaLabel;
    return (0, $lLkqw.h)("select", {
        className: (0, $5bown.cx)(cssClasses.select),
        onChange: function onChange(event) {
            return setValue(event.target.value);
        },
        value: "".concat(currentValue),
        "aria-label": ariaLabel
    }, options.map(function(option) {
        return (0, $lLkqw.h)("option", {
            className: (0, $5bown.cx)(cssClasses.option),
            key: option.label + option.value,
            value: "".concat(option.value)
        }, option.label);
    }));
}
var $ab2fa6417f0ecf8b$export$2e2bcd8739ae039 = $ab2fa6417f0ecf8b$var$Selector;



var $6YH5z = parcelRequire("6YH5z");
var $kooa4 = parcelRequire("kooa4");
var $eHfFT = parcelRequire("eHfFT");
var $fMELL = parcelRequire("fMELL");
function $483b034df19b7ca3$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $483b034df19b7ca3$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $483b034df19b7ca3$var$_typeof(obj);
}
function $483b034df19b7ca3$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $483b034df19b7ca3$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $483b034df19b7ca3$var$ownKeys(Object(source), !0).forEach(function(key) {
            $483b034df19b7ca3$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $483b034df19b7ca3$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $483b034df19b7ca3$var$_defineProperty(obj, key, value) {
    key = $483b034df19b7ca3$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $483b034df19b7ca3$var$_toPropertyKey(arg) {
    var key = $483b034df19b7ca3$var$_toPrimitive(arg, "string");
    return $483b034df19b7ca3$var$_typeof(key) === "symbol" ? key : String(key);
}
function $483b034df19b7ca3$var$_toPrimitive(input, hint) {
    if ($483b034df19b7ca3$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($483b034df19b7ca3$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var $483b034df19b7ca3$var$withUsage = (0, $kooa4.createDocumentationMessageGenerator)({
    name: 'sort-by',
    connector: true
});
/**
 * The **SortBy** connector provides the logic to build a custom widget that will display a
 * list of indices. With Algolia, this is most commonly used for changing ranking strategy. This allows
 * a user to change how the hits are being sorted.
 */ var $483b034df19b7ca3$var$connectSortBy = function connectSortBy(renderFn) {
    var unmountFn = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (0, $fMELL.noop);
    (0, $6YH5z.checkRendering)(renderFn, $483b034df19b7ca3$var$withUsage());
    var connectorState = {};
    return function(widgetParams) {
        var _ref = widgetParams || {}, items = _ref.items, _ref$transformItems = _ref.transformItems, transformItems = _ref$transformItems === void 0 ? function(x) {
            return x;
        } : _ref$transformItems;
        if (!Array.isArray(items)) throw new Error($483b034df19b7ca3$var$withUsage('The `items` option expects an array of objects.'));
        return {
            $$type: 'ais.sortBy',
            init: function init(initOptions) {
                var instantSearchInstance = initOptions.instantSearchInstance;
                var widgetRenderState = this.getWidgetRenderState(initOptions);
                var currentIndex = widgetRenderState.currentRefinement;
                var isCurrentIndexInItems = (0, $eHfFT.find)(items, function(item) {
                    return item.value === currentIndex;
                });
                renderFn($483b034df19b7ca3$var$_objectSpread($483b034df19b7ca3$var$_objectSpread({}, widgetRenderState), {}, {
                    instantSearchInstance: instantSearchInstance
                }), true);
            },
            render: function render(renderOptions) {
                var instantSearchInstance = renderOptions.instantSearchInstance;
                renderFn($483b034df19b7ca3$var$_objectSpread($483b034df19b7ca3$var$_objectSpread({}, this.getWidgetRenderState(renderOptions)), {}, {
                    instantSearchInstance: instantSearchInstance
                }), false);
            },
            dispose: function dispose(_ref2) {
                var state = _ref2.state;
                unmountFn();
                return connectorState.initialIndex ? state.setIndex(connectorState.initialIndex) : state;
            },
            getRenderState: function getRenderState(renderState, renderOptions) {
                return $483b034df19b7ca3$var$_objectSpread($483b034df19b7ca3$var$_objectSpread({}, renderState), {}, {
                    sortBy: this.getWidgetRenderState(renderOptions)
                });
            },
            getWidgetRenderState: function getWidgetRenderState(_ref3) {
                var results = _ref3.results, helper = _ref3.helper, state = _ref3.state, parent = _ref3.parent;
                if (!connectorState.initialIndex && parent) connectorState.initialIndex = parent.getIndexName();
                if (!connectorState.setIndex) connectorState.setIndex = function(indexName) {
                    helper.setIndex(indexName).search();
                };
                var hasNoResults = results ? results.nbHits === 0 : true;
                return {
                    currentRefinement: state.index,
                    options: transformItems(items, {
                        results: results
                    }),
                    refine: connectorState.setIndex,
                    hasNoResults: hasNoResults,
                    canRefine: !hasNoResults && items.length > 0,
                    widgetParams: widgetParams
                };
            },
            getWidgetUiState: function getWidgetUiState(uiState, _ref4) {
                var searchParameters = _ref4.searchParameters;
                var currentIndex = searchParameters.index;
                return $483b034df19b7ca3$var$_objectSpread($483b034df19b7ca3$var$_objectSpread({}, uiState), {}, {
                    sortBy: currentIndex !== connectorState.initialIndex ? currentIndex : undefined
                });
            },
            getWidgetSearchParameters: function getWidgetSearchParameters(searchParameters, _ref5) {
                var uiState = _ref5.uiState;
                return searchParameters.setQueryParameter('index', uiState.sortBy || connectorState.initialIndex || searchParameters.index);
            }
        };
    };
};
var $483b034df19b7ca3$export$2e2bcd8739ae039 = $483b034df19b7ca3$var$connectSortBy;



var $8JLyQ = parcelRequire("8JLyQ");

var $kooa4 = parcelRequire("kooa4");
var $hthTp = parcelRequire("hthTp");
function $6a97425bb8fc5a3a$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $6a97425bb8fc5a3a$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $6a97425bb8fc5a3a$var$_typeof(obj);
}
function $6a97425bb8fc5a3a$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $6a97425bb8fc5a3a$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $6a97425bb8fc5a3a$var$ownKeys(Object(source), !0).forEach(function(key) {
            $6a97425bb8fc5a3a$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $6a97425bb8fc5a3a$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $6a97425bb8fc5a3a$var$_defineProperty(obj, key, value) {
    key = $6a97425bb8fc5a3a$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $6a97425bb8fc5a3a$var$_toPropertyKey(arg) {
    var key = $6a97425bb8fc5a3a$var$_toPrimitive(arg, "string");
    return $6a97425bb8fc5a3a$var$_typeof(key) === "symbol" ? key : String(key);
}
function $6a97425bb8fc5a3a$var$_toPrimitive(input, hint) {
    if ($6a97425bb8fc5a3a$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($6a97425bb8fc5a3a$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var $6a97425bb8fc5a3a$var$withUsage = (0, $kooa4.createDocumentationMessageGenerator)({
    name: 'sort-by'
});
var $6a97425bb8fc5a3a$var$suit = (0, $8JLyQ.component)('SortBy');
var $6a97425bb8fc5a3a$var$renderer = function renderer(_ref) {
    var containerNode = _ref.containerNode, cssClasses = _ref.cssClasses;
    return function(_ref2, isFirstRendering) {
        var currentRefinement = _ref2.currentRefinement, options = _ref2.options, refine = _ref2.refine;
        if (isFirstRendering) return;
        (0, $lLkqw.render)((0, $lLkqw.h)("div", {
            className: cssClasses.root
        }, (0, $lLkqw.h)((0, $ab2fa6417f0ecf8b$export$2e2bcd8739ae039), {
            cssClasses: cssClasses,
            currentValue: currentRefinement,
            options: options,
            setValue: refine,
            ariaLabel: "Sort results by"
        })), containerNode);
    };
};
/**
 * Sort by selector is a widget used for letting the user choose between different
 * indices that contains the same data with a different order / ranking formula.
 */ var $6a97425bb8fc5a3a$var$sortBy = function sortBy(widgetParams) {
    var _ref3 = widgetParams || {}, container = _ref3.container, items = _ref3.items, _ref3$cssClasses = _ref3.cssClasses, userCssClasses = _ref3$cssClasses === void 0 ? {} : _ref3$cssClasses, transformItems = _ref3.transformItems;
    if (!container) throw new Error($6a97425bb8fc5a3a$var$withUsage('The `container` option is required.'));
    var containerNode = (0, $hthTp.getContainerNode)(container);
    var cssClasses = {
        root: (0, $5bown.cx)($6a97425bb8fc5a3a$var$suit(), userCssClasses.root),
        select: (0, $5bown.cx)($6a97425bb8fc5a3a$var$suit({
            descendantName: 'select'
        }), userCssClasses.select),
        option: (0, $5bown.cx)($6a97425bb8fc5a3a$var$suit({
            descendantName: 'option'
        }), userCssClasses.option)
    };
    var specializedRenderer = $6a97425bb8fc5a3a$var$renderer({
        containerNode: containerNode,
        cssClasses: cssClasses
    });
    var makeWidget = (0, $483b034df19b7ca3$export$2e2bcd8739ae039)(specializedRenderer, function() {
        return (0, $lLkqw.render)(null, containerNode);
    });
    return $6a97425bb8fc5a3a$var$_objectSpread($6a97425bb8fc5a3a$var$_objectSpread({}, makeWidget({
        container: containerNode,
        items: items,
        transformItems: transformItems
    })), {}, {
        $$widgetType: 'ais.sortBy'
    });
};
var $6a97425bb8fc5a3a$export$2e2bcd8739ae039 = $6a97425bb8fc5a3a$var$sortBy;


var $9MfiC = parcelRequire("9MfiC");

var $8kn2n = parcelRequire("8kn2n");

var $6ACgD = parcelRequire("6ACgD");

var $eomKw = parcelRequire("eomKw");
var $2e52ca37bfb0c087$exports = {};
var $144353798d881609$exports = {};
$144353798d881609$exports = new URL("amazon_icon.637b370d.svg", import.meta.url).toString();


var $43fb0f2c899b1ef2$exports = {};
$43fb0f2c899b1ef2$exports = new URL("archive_icon.b93ca50a.svg", import.meta.url).toString();


var $2dd7034b892b47a7$exports = {};
$2dd7034b892b47a7$exports = new URL("generic_link_icon.3aa6c58d.svg", import.meta.url).toString();


var $d4f60b7ced2ff069$exports = {};
$d4f60b7ced2ff069$exports = new URL("opengraph_banner.c6e2d394.png", import.meta.url).toString();


var $cf8c24edb693a030$exports = {};
$cf8c24edb693a030$exports = new URL("typesense.3867b908.svg", import.meta.url).toString();


$2e52ca37bfb0c087$exports = {
    "amazon_icon": {
        "svg": $144353798d881609$exports
    },
    "archive_icon": {
        "svg": $43fb0f2c899b1ef2$exports
    },
    "generic_link_icon": {
        "svg": $2dd7034b892b47a7$exports
    },
    "opengraph_banner": {
        "png": $d4f60b7ced2ff069$exports
    },
    "typesense": {
        "svg": $cf8c24edb693a030$exports
    }
};


var $24b19b460b4d3af3$exports = {};
$24b19b460b4d3af3$exports = JSON.parse("[\"a\",\"am\",\"an\",\"and\",\"as\",\"at\",\"by\",\"c's\",\"co\",\"do\",\"de\",\"eg\",\"et\",\"for\",\"he\",\"hi\",\"i\",\"i'd\",\"i'm\",\"ie\",\"if\",\"in\",\"inc\",\"is\",\"it\",\"its\",\"me\",\"my\",\"nd\",\"no\",\"non\",\"nor\",\"not\",\"of\",\"off\",\"oh\",\"ok\",\"on\",\"or\",\"per\",\"que\",\"qv\",\"rd\",\"re\",\"so\",\"sub\",\"t's\",\"th\",\"the\",\"to\",\"too\",\"two\",\"un\",\"up\",\"us\",\"vs\",\"we\"]");


window.$ = (0, (/*@__PURE__*/$parcel$interopDefault($9YEav))); // workaround for https://github.com/parcel-bundler/parcel/issues/333
// Source: https://stackoverflow.com/a/901144/123545
const $e52b6c332144f7ae$var$anchorParams = new Proxy(new URLSearchParams(window.location.hash.replace("#", "")), {
    get: (anchorParams, prop)=>anchorParams.get(prop)
});
let $e52b6c332144f7ae$var$TYPESENSE_SERVER_CONFIG = {
    apiKey: "3FE6XjoV2QHVjUyVdXs4eh4aw8MduZY8",
    nodes: [
        {
            host: $e52b6c332144f7ae$var$anchorParams.host ? $e52b6c332144f7ae$var$anchorParams.host : "searchbible.net",
            port: "443",
            protocol: "https",
            path: '/api/ts' // <- ADD this new line (no comma needed after)
        }
    ],
    numRetries: 8,
    useServerSideSearchCache: false
};
const $e52b6c332144f7ae$var$INDEX_NAME = "kjvbible2026";
async function $e52b6c332144f7ae$var$getIndexSize() {
    let typesenseSearchClient = new (0, $eomKw.SearchClient)({
        ...$e52b6c332144f7ae$var$TYPESENSE_SERVER_CONFIG,
        useServerSideSearchCache: true
    });
    let results = await typesenseSearchClient.collections($e52b6c332144f7ae$var$INDEX_NAME).documents().search({
        q: "*"
    });
    return results["found"];
}
let $e52b6c332144f7ae$var$indexSize;
(async ()=>{
    $e52b6c332144f7ae$var$indexSize = await $e52b6c332144f7ae$var$getIndexSize();
})();
function $e52b6c332144f7ae$var$iconForUrl(url) {
    if (url.includes("amazon.com")) return (0, (/*@__PURE__*/$parcel$interopDefault($2e52ca37bfb0c087$exports)))["amazon_icon"]["svg"];
    else if (url.includes("openlibrary")) return (0, (/*@__PURE__*/$parcel$interopDefault($2e52ca37bfb0c087$exports)))["archive_icon"]["svg"];
    else return (0, (/*@__PURE__*/$parcel$interopDefault($2e52ca37bfb0c087$exports)))["generic_link_icon"]["svg"];
}
function $e52b6c332144f7ae$var$topMarginForUrl(url) {
    if (url.includes("amazon.com")) return 1;
    else return 0;
}
function $e52b6c332144f7ae$var$urlsObjectsForBookObject(bookObject) {
    let urls = [];
    /*
  if (bookObject["isbn_10"]) {
    urls.push(`https://www.amazon.com/dp/${bookObject["isbn_10"]}`);
  } else if (bookObject.isbn_13) {
    urls.push(`https://www.amazon.com/s?k=${bookObject["isbn_13"]}`);
  }
*/ urls.push(`https://www.kingjamesbibleonline.org/search.php?q=${bookObject["id"]}`);
    /*urls.push(`https://openlibrary.org${bookObject["id"]}`);*/ return urls.map((u)=>{
        return {
            url: u,
            icon: $e52b6c332144f7ae$var$iconForUrl(u),
            topMargin: $e52b6c332144f7ae$var$topMarginForUrl(u)
        };
    });
}
function $e52b6c332144f7ae$var$queryWithoutStopWords(query) {
    const words = query.replace(/[&/\\#,+()$~%.':*?<>{}]/g, "").split(" ");
    return words.map((word)=>{
        if ((0, (/*@__PURE__*/$parcel$interopDefault($24b19b460b4d3af3$exports))).includes(word.toLowerCase())) return null;
        else return word;
    }).filter((w)=>w).join(" ").trim();
}
const $e52b6c332144f7ae$var$typesenseInstantsearchAdapter = new (0, (/*@__PURE__*/$parcel$interopDefault($6ACgD)))({
    server: $e52b6c332144f7ae$var$TYPESENSE_SERVER_CONFIG,
    // The following parameters are directly passed to Typesense's search API endpoint.
    //  So you can pass any parameters supported by the search endpoint below.
    //  queryBy is required.
    additionalSearchParameters: {
        query_by: "vtext,titles,names",
        facet_sample_threshold: 1000,
        facet_sample_percent: 20
    }
});
const $e52b6c332144f7ae$var$searchClient = $e52b6c332144f7ae$var$typesenseInstantsearchAdapter.searchClient;
const $e52b6c332144f7ae$var$search = (0, $a9ZSp.default)({
    searchClient: $e52b6c332144f7ae$var$searchClient,
    indexName: $e52b6c332144f7ae$var$INDEX_NAME,
    initialUiState: {
        [$e52b6c332144f7ae$var$INDEX_NAME]: {
            refinementList: {
                bsect: [
                    'O',
                    'N'
                ]
            }
        }
    },
    routing: {
        router: (0, $8kn2n.default)({
            cleanUrlOnDispose: true
        })
    },
    onStateChange ({ uiState: uiState, setUiState: setUiState }) {
        if (uiState[$e52b6c332144f7ae$var$INDEX_NAME].query === "") $("#results-section").addClass("d-none");
        else {
            $("#results-section").removeClass("d-none");
            setUiState(uiState);
        }
    },
    future: {
        preserveSharedStateOnUnmount: true
    }
});
const $e52b6c332144f7ae$var$analyticsMiddleware = ()=>{
    return {
        onStateChange () {
        /*window.ga(
        "set",
        "page",
        (window.location.pathname + window.location.search).toLowerCase()
      );
      window.ga("send", "pageView");
	  */ },
        subscribe () {},
        unsubscribe () {}
    };
};
$e52b6c332144f7ae$var$search.use($e52b6c332144f7ae$var$analyticsMiddleware);
let $e52b6c332144f7ae$var$debounceTimerId;
$e52b6c332144f7ae$var$search.addWidgets([
    (0, $6692ff1d889f1f11$export$2e2bcd8739ae039)({
        container: "#searchbox",
        showSubmit: false,
        showReset: false,
        placeholder: "Type in Bible verses or search words here...",
        autofocus: true,
        cssClasses: {
            input: "form-control searchbox-input"
        },
        queryHook (query, search) {
            const modifiedQuery = query;
            /* const modifiedQuery = queryWithoutStopWords(query); */ /*this removes stopwords from query*/ if (modifiedQuery.trim() !== "" && modifiedQuery.trim().length > 2) {
                if ($e52b6c332144f7ae$var$debounceTimerId) clearTimeout($e52b6c332144f7ae$var$debounceTimerId);
                $e52b6c332144f7ae$var$debounceTimerId = setTimeout(()=>search(modifiedQuery), 250);
            }
        }
    }),
    (0, $9MfiC.default)({
        container: "#stats",
        templates: {
            text: ({ nbHits: nbHits, hasNoResults: hasNoResults, hasOneResult: hasOneResult, processingTimeMS: processingTimeMS })=>{
                let statsText = "";
                if (hasNoResults) statsText = "No results";
                else if (hasOneResult) statsText = "1 result";
                else statsText = `\u{2728} ${nbHits.toLocaleString()} results`;
                return `${statsText} found ${$e52b6c332144f7ae$var$indexSize ? ` - Searched ${$e52b6c332144f7ae$var$indexSize.toLocaleString()} books` : ""} in ${processingTimeMS}ms.`;
            }
        }
    }),
    /*
  infiniteHits({
    container: "#hits",
    cssClasses: {
      list: "list-unstyled grid-container",
	  item: "d-flex flex-column search-result-card bg-light-2 p-3",
      item: "d-flex flex-column p-3",
      loadMore: "btn btn-primary mx-auto d-block mt-4",
    },
	*/ (0, $d5S8e.default)({
        container: "#hits",
        cssClasses: {
            list: "list-unstyled",
            item: "d-flex flex-column p-3 resultscolor",
            loadMore: "btn btn-primary mx-auto d-block mt-4"
        },
        templates: {
            item: (hit, { html: html, components: components })=>html`
        <div class="mb-0">
          <a href="https://www.kingjamesbibleonline.org/${hit.bname.replace(/ /g, '-')}-${hit.cnum}-${hit.vnum}/" target="_blank">
            <b class='dred'>${hit.bname} ${hit.cnum}:${hit.vnum}</b>
          </a><br />
          <span style="color:black;font-size:1.1rem;">${components.Highlight({
                    hit: hit,
                    attribute: "vtext"
                })}</span>
        </div>
      `,
            empty: (state, { html: html })=>html`No results found for <q>${state.query}</q>. Please try another search term.`
        },
        transformItems: (items)=>{
            return items.map((item)=>{
                return {
                    ...item,
                    urls: $e52b6c332144f7ae$var$urlsObjectsForBookObject(item)
                };
            });
        }
    }),
    (0, $2wrqp.default)({
        container: "#author-refinement-list",
        attribute: "titles",
        searchable: true,
        searchablePlaceholder: "Search by story",
        showMore: true,
        showMoreLimit: 40,
        cssClasses: {
            searchableInput: "form-control form-control-sm mb-2 border-light-2",
            searchableSubmit: "d-none",
            searchableReset: "d-none",
            showMore: "btn btn-secondary btn-sm align-content-center",
            list: "list-unstyled",
            count: "badge bg-light text-bg-light ms-2",
            label: "d-flex align-items-center text-capitalize mb-2",
            checkbox: "me-2"
        }
    }),
    (0, $2wrqp.default)({
        container: "#subjects-refinement-list",
        attribute: "names",
        searchable: true,
        searchablePlaceholder: "Search names",
        showMore: true,
        showMoreLimit: 40,
        cssClasses: {
            searchableInput: "form-control form-control-sm mb-2 border-light-2",
            searchableSubmit: "d-none",
            searchableReset: "d-none",
            showMore: "btn btn-secondary btn-sm align-content-center",
            list: "list-unstyled",
            count: "badge bg-light text-bg-light ms-2",
            label: "d-flex align-items-center text-capitalize mb-2",
            checkbox: "me-2"
        }
    }),
    (0, $2wrqp.default)({
        container: "#topics-refinement-list",
        attribute: "topics",
        searchable: true,
        searchablePlaceholder: "Search topics",
        showMore: true,
        showMoreLimit: 40,
        cssClasses: {
            searchableInput: "form-control form-control-sm mb-2 border-light-2",
            searchableSubmit: "d-none",
            searchableReset: "d-none",
            showMore: "btn btn-secondary btn-sm align-content-center",
            list: "list-unstyled",
            count: "badge bg-light text-bg-light ms-2",
            label: "d-flex align-items-center text-capitalize mb-2",
            checkbox: "me-2"
        }
    }),
    (0, $2wrqp.default)({
        container: "#emojis-refinement-list",
        attribute: "emojis",
        searchable: true,
        searchablePlaceholder: "Search emojis",
        showMore: true,
        showMoreLimit: 40,
        cssClasses: {
            searchableInput: "form-control form-control-sm mb-2 border-light-2",
            searchableSubmit: "d-none",
            searchableReset: "d-none",
            showMore: "btn btn-secondary btn-sm align-content-center",
            list: "list-unstyled",
            count: "badge bg-light text-bg-light ms-2",
            label: "d-flex align-items-center text-capitalize mb-2",
            checkbox: "me-2"
        }
    }),
    (0, $2wrqp.default)({
        container: "#place-refinement-list",
        attribute: "place",
        searchable: true,
        searchablePlaceholder: "Search places",
        showMore: true,
        showMoreLimit: 40,
        cssClasses: {
            searchableInput: "form-control form-control-sm mb-2 border-light-2",
            searchableSubmit: "d-none",
            searchableReset: "d-none",
            showMore: "btn btn-secondary btn-sm align-content-center",
            list: "list-unstyled",
            count: "badge bg-light text-bg-light ms-2",
            label: "d-flex align-items-center text-capitalize mb-2",
            checkbox: "me-2"
        }
    }),
    (0, $hHIOY.default)({
        hitsPerPage: 15
    }),
    (0, $6a97425bb8fc5a3a$export$2e2bcd8739ae039)({
        container: "#sort-by",
        items: [
            {
                label: "Relevance",
                value: `${$e52b6c332144f7ae$var$INDEX_NAME}`
            },
            {
                label: "Book order",
                value: `${$e52b6c332144f7ae$var$INDEX_NAME}/sort/vid:asc`
            }
        ],
        cssClasses: {
            select: "form-select form-select-sm"
        }
    }),
    (0, $e2pZd.default)({
        container: "#current-refinements",
        cssClasses: {
            list: "list-unstyled",
            label: "d-none",
            item: "h5",
            category: "badge bg-light text-bg-light px-3 m-2",
            categoryLabel: "text-capitalize",
            delete: "btn btn-sm btn-link p-0 ps-2"
        },
        transformItems: (items)=>{
            const modifiedItems = items.map((item)=>{
                return {
                    ...item,
                    label: ""
                };
            });
            return modifiedItems;
        }
    })
]);
function $e52b6c332144f7ae$var$handleSearchTermClick(event) {
    const $searchBox = $("#searchbox input[type=search]");
    $e52b6c332144f7ae$var$search.helper.clearRefinements();
    $searchBox.val(event.currentTarget.textContent);
    $e52b6c332144f7ae$var$search.helper.setQuery($searchBox.val()).search();
}
$e52b6c332144f7ae$var$search.on("render", function() {
    // Make author names clickable
    $("#hits .clickable-search-term").on("click", $e52b6c332144f7ae$var$handleSearchTermClick);
    // Read directions button
    $(".readDirectionsButton").on("click", (event)=>{
        $(event.currentTarget).parent().siblings().first().modal("show");
    });
});
$e52b6c332144f7ae$var$search.start();
$(function() {
    const $searchBox = $("#searchbox input[type=search]");
    // Testament filter checkboxes
    function updateTestamentFilter() {
        const parts = [];
        if ($("#chk-old").is(":checked")) parts.push("bsect:O");
        if ($("#chk-new").is(":checked")) parts.push("bsect:N");
        if ($("#chk-apocrypha").is(":checked")) parts.push("bsect:A");
        const filterStr = parts.length ? parts.join(" || ") : "bsect:O || bsect:N";
        $e52b6c332144f7ae$var$search.helper.setQueryParameter("filters", filterStr).search();
    }
    $("#chk-old, #chk-new, #chk-apocrypha").on("change", updateTestamentFilter);
    // Apply default testament filter on load
    $e52b6c332144f7ae$var$search.helper.setQueryParameter("filters", "bsect:O || bsect:N");
    // Search on page refresh with the query restored from URL params
    if ($searchBox.val().trim() !== "") $e52b6c332144f7ae$var$search.helper.setQuery($searchBox.val()).search();
    // Handle example search terms
    $(".clickable-search-term").on("click", $e52b6c332144f7ae$var$handleSearchTermClick);
    // Clear refinements, when searching (but preserve testament filter)
    $searchBox.on("keydown", ()=>{
        $e52b6c332144f7ae$var$search.helper.clearRefinements('titles').clearRefinements('names').clearRefinements('topics').clearRefinements('emojis').clearRefinements('place');
    });
    if (!matchMedia("(min-width: 768px)").matches) $searchBox.on("focus, keydown", ()=>{
        $("html, body").animate({
            scrollTop: $("#searchbox-container").offset().top
        }, 500);
    });
});


//# sourceMappingURL=index.bc83dfed.js.map
